import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { UserProfileMode } from '../enums/user-profile.mode.enum';

/**
 * Page d'atterrissage à la connexion (route racine) :
 *  - mode TENANT → /administrative/ticket-home ;
 *  - mode CORE → /settings (les routes administrative sont derrière ModeTenantGuard,
 *    qui renverrait un utilisateur CORE vers `/` en boucle infinie).
 * Retourne une UrlTree : redirection gérée par le router, sans navigation impérative.
 */
@Injectable({
  providedIn: 'root',
})
export class HomeRedirectGuard {
  constructor(
    private router: Router,
    public authService: AuthService,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.currentUserValue$().pipe(
      map(user => {
        if (user && user.mode === UserProfileMode.CORE) {
          return this.router.parseUrl('/settings');
        }
        if (user) {
          return this.router.parseUrl('/administrative/ticket-home');
        }
      }),
      catchError(() => {
        return of(false);
      }),
    );
  }
}
